import { Mutex } from 'async-mutex';

/**
 * Single shared mutex for token refresh across both RTK Query (rest-api.ts)
 * and legacy axios interceptors (axiosInstance.tsx).
 *
 * Prevents concurrent /token/refresh calls when multiple requests
 * receive 401s simultaneously.
 */
export const authMutex = new Mutex();
